/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ColumnResizedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import {
  faTrashCan,
  faMagnifyingGlass,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css";
import { DeleteTileModal } from "../components/Tile-management/DeleteTileModal";
import { AddTileModal } from "../components/Tile-management/AddTileModal";
import { TileDetailsModal } from "../components/Tile-management/TileDetailsModal";
import { PillInfo } from "../../../services/types/gallus";
import Select, { SingleValue } from "react-select";
import { ReactSelectOption } from "../../Interfaces";
import {
  useAddPillMutation,
  useDeletePillMutation,
  useLazyGetPillsByWorkspaceQuery,
  useLazyIsProductDisabledQuery,
  useUpdatePillMutation,
  useUpdateProductStatusByNameMutation,
} from "../../../services/gallusTools";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface AdminTileManagementProps {
  environmentCode: "PR_PROD_" | "PR_UAT_";
}

interface AdminTileList {
  name: string;
  url: string;
  disabled: boolean;
}

export const AdminTileManagement = (props: AdminTileManagementProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [errorModalIsOpen, setErrorModalIsOpen] = useState<boolean>(false);
  const [deleteTileModalIsOpen, setDeleteTileModalIsOpen] =
    useState<boolean>(false);
  const [addTileModalIsOpen, setAddTileModalIsOpen] = useState<boolean>(false);
  const [TileDetailsModalIsOpen, setTileDetailsModalIsOpen] =
    useState<boolean>(false);
  const [TileData, setTileData] = useState<AdminTileList[]>([]);
  const [selectedTileID, setSelectedTileID] = useState<number>();
  const workspaceOptions: ReactSelectOption[] = [
    { value: props.environmentCode + "Executive", label: "Executive" },
    { value: props.environmentCode + "Operations", label: "Operations" },
    { value: props.environmentCode + "Retail", label: "Retail" },
    { value: props.environmentCode + "Wholesale", label: "Wholesale" },
    { value: props.environmentCode + "Admin", label: "Admin" },
    { value: props.environmentCode + "ChrisGax", label: "Chris/Gax" },
  ];
  const [workspace, setWorkspace] = useState<ReactSelectOption>(
    workspaceOptions[0],
  );

  const [getTilesQuery, getTilesQueryResult] =
    useLazyGetPillsByWorkspaceQuery();
  const [addTileQuery, addTileQueryResult] = useAddPillMutation();
  const [updateTileQuery, updateTileQueryResult] = useUpdatePillMutation();
  const [deleteTileQuery, deleteTileQueryResult] = useDeletePillMutation();
  const [isProductDisabledQuery, isProductDisabledResult] =
    useLazyIsProductDisabledQuery();
  const [updateProductQuery] = useUpdateProductStatusByNameMutation();
  const [productIsDisabled, setProductIsDisabled] = useState<boolean>();
  const [changeProductAvailabilityIntent, setChangeProductAvailabilityIntent] =
    useState<boolean>(false);

  useEffect(() => {
    const checkDisabled = async () => {
      let productToCheck: string = "";

      if (props.environmentCode === "PR_PROD_") {
        productToCheck = "PRMG Prod";
      } else {
        productToCheck = "PRMG UAT";
      }

      await isProductDisabledQuery({
        productName: productToCheck,
      });
    };
    checkDisabled();
  }, [props]);

  useEffect(() => {
    if (
      isProductDisabledResult.isSuccess &&
      isProductDisabledResult.status === "fulfilled"
    ) {
      setProductIsDisabled(isProductDisabledResult.data);
    }
  }, [isProductDisabledResult]);

  useEffect(() => {
    if (addTileQueryResult.isError) {
      setErrorModalIsOpen(true);
    }
  }, [addTileQueryResult]);

  useEffect(() => {
    if (updateTileQueryResult.isError) {
      setErrorModalIsOpen(true);
    }
  }, [updateTileQueryResult]);

  const toggleAddTileModal = () => {
    setAddTileModalIsOpen(!addTileModalIsOpen);
  };

  const toggleTileDetailsModal = () => {
    setTileDetailsModalIsOpen(!TileDetailsModalIsOpen);
  };

  const toggleDeleteTileModal = () => {
    setDeleteTileModalIsOpen(!deleteTileModalIsOpen);
  };

  /*   const [lazyGetTilesQuery, lazyGetTilesResults] =
    useLazyGetTilesQuery(); */

  const columnDefinitions = [
    {
      field: "name",
      headerName: "Name",
      cellRenderer: (params: {
        data: {
          disabled: boolean;
          name: string;
          options: number;
          url: string;
        };
      }) => {
        return (
          <div className={params.data.disabled ? "red" : ""}>
            {params.data.name}
          </div>
        );
      },
    },
    {
      field: "url",
      headerName: "URL",
      cellRenderer: (params: {
        data: {
          disabled: boolean;
          name: string;
          options: number;
          url: string;
        };
      }) => {
        return (
          <div className={params.data.disabled ? "red" : ""}>
            {params.data.url}
          </div>
        );
      },
    } /* 
    {
      field: "disabled",
      headerName: "Disabled",
      width: 80,
      cellRenderer: (params: {
        data: {
          disabled: boolean;
          name: string;
          options: number;
          url: string;
        };
      }) => {
        let returnValue = params.data.disabled ? (
          <div>
            <FontAwesomeIcon className="me-2" icon={faCheck} />
          </div>
        ) : (
          <></>
        );
        return returnValue;
      },
    }, */,
    {
      field: "options",
      headerName: "Options",
      cellRenderer: (params: { value: string }) => {
        return (
          <div>
            <button
              className="button-no-background"
              onClick={() => {
                if (typeof params.value !== "undefined") {
                  setSelectedTileID(Number(params.value));
                  setTileDetailsModalIsOpen(true);
                }
              }}
            >
              <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} />
            </button>
            <button
              className="button-no-background"
              onClick={() => {
                if (typeof params.value !== "undefined") {
                  setSelectedTileID(Number(params.value));
                  setDeleteTileModalIsOpen(true);
                }
              }}
            >
              <FontAwesomeIcon className="me-2" icon={faTrashCan} />
            </button>
          </div>
        );
      },
    },
  ];

  const generateTileRowData = (Tiles: PillInfo[]) => {
    return Tiles.map((Tile) => {
      return {
        name: Tile.title,
        url: Tile.link,
        disabled: Tile.currentlyDisabled,
        options: Tile.id,
      };
    });
  };

  useEffect(() => {
    if (workspace) {
      setLoading(true);
      getTilesQuery({ workspace: workspace.value });
    }
  }, [workspace]);

  useEffect(() => {
    if (
      getTilesQueryResult.isSuccess &&
      getTilesQueryResult.status === "fulfilled"
    ) {
      setTileData(generateTileRowData(getTilesQueryResult.data));
      setLoading(false);
    }
  }, [getTilesQueryResult]);

  function onGridReady(params: ColumnResizedEvent) {
    params.api.sizeColumnsToFit();
  }

  return (
    <div className="container roundedCorners">
      <div className="mb-2">
        <div>
          <div
            className="col-12 module-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            Landing Page Management
            {props.environmentCode === "PR_PROD_" ? " (Prod)" : " (UAT)"}
            {productIsDisabled ? (
              <div style={{ color: "red", fontSize: "xx-large" }}>
                Currently Disabled
              </div>
            ) : (
              <></>
            )}
            <button
              className="btn btn-primary"
              style={{
                backgroundColor: !productIsDisabled ? "red" : "blue",
                borderColor: !productIsDisabled ? "red" : "blue",
              }}
              type="submit"
              disabled={loading}
              onClick={() => {
                setChangeProductAvailabilityIntent(true);
              }}
            >
              {productIsDisabled ? "Enable Product" : "Disable Product"}
            </button>
          </div>
        </div>
      </div>
      {loading && (
        <div className="loading-div">
          <FontAwesomeIcon
            icon={faSpinner}
            size="2x"
            spin={true}
            style={{ margin: "0 auto" }}
          />
        </div>
      )}
      {!loading && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "20px",
            }}
          >
            <div>
              Select Workspace:
              <Select
                placeholder="Select Workspace"
                onChange={(
                  selectedWorkspace: SingleValue<ReactSelectOption>,
                ) => {
                  if (selectedWorkspace !== null) {
                    setWorkspace(selectedWorkspace);
                  }
                }}
                options={workspaceOptions}
                className="basic-multi-select width-min-200"
                classNamePrefix="select"
                value={workspace}
              />
            </div>
            <div>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
                onClick={() => setAddTileModalIsOpen(true)}
              >
                Add Tile
              </button>
            </div>
          </div>
          <div>
            <AgGridReact
              domLayout={"autoHeight"}
              defaultColDef={{
                cellClass: "grid-generic-text",
                headerClass: "grid-generic-column",
              }}
              onGridReady={onGridReady}
              rowData={TileData}
              columnDefs={columnDefinitions}
            />
          </div>
        </div>
      )}
      <DeleteTileModal
        selectedTileID={selectedTileID!}
        deleteTileFunction={() => {
          if (selectedTileID) {
            deleteTileQuery({ pillID: selectedTileID });
          }
        }}
        modalIsOpen={deleteTileModalIsOpen}
        toggleModal={toggleDeleteTileModal}
      />
      <TileDetailsModal
        modalIsOpen={TileDetailsModalIsOpen}
        selectedTileID={selectedTileID!}
        updateTileFunction={(
          title: string,
          url: string,
          disabledState: boolean,
        ) => {
          if (selectedTileID) {
            updateTileQuery({
              id: selectedTileID.toString(),
              title,
              url,
              workspace: workspace.value,
              currentlyDisabledState: disabledState,
            });
          }
        }}
        toggleModal={toggleTileDetailsModal}
      />
      <AddTileModal
        addTileFunction={(title: string, url: string) => {
          addTileQuery({ title, url, workspace: workspace.value });
        }}
        selectedWorkspace={workspace.value}
        modalIsOpen={addTileModalIsOpen}
        toggleModal={toggleAddTileModal}
      />
      <Modal
        isOpen={errorModalIsOpen}
        toggle={() => setErrorModalIsOpen(!errorModalIsOpen)}
      >
        <ModalHeader toggle={() => setErrorModalIsOpen(!errorModalIsOpen)}>
          Invalid URL
        </ModalHeader>
        <div>
          <ModalBody>
            <div>
              <div
                style={{
                  fontSize: "larger",
                  paddingBottom: "5px",
                }}
              >
                You have submitted an invalid URL. Please make sure the URL
                includes liveboard GUID.
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                setErrorModalIsOpen(false);
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </div>
      </Modal>
      <Modal
        isOpen={changeProductAvailabilityIntent}
        toggle={() =>
          setChangeProductAvailabilityIntent(!changeProductAvailabilityIntent)
        }
      >
        <ModalHeader
          toggle={() =>
            setChangeProductAvailabilityIntent(!changeProductAvailabilityIntent)
          }
        >
          Invalid URL
        </ModalHeader>
        <div>
          <ModalBody>
            <div>
              <div
                style={{
                  fontSize: "larger",
                  paddingBottom: "5px",
                }}
              >
                Are you sure you want to{" "}
                {productIsDisabled ? " enable " : " disable "} this product?
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                setChangeProductAvailabilityIntent(false);
              }}
            >
              Close
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                let productToCheck: string = "";
                if (props.environmentCode === "PR_PROD_") {
                  productToCheck = "PRMG Prod";
                } else {
                  productToCheck = "PRMG UAT";
                }
                updateProductQuery({
                  newIsDisabledStatus: !productIsDisabled,
                  productNameArray: [productToCheck],
                });
                setChangeProductAvailabilityIntent(false);
              }}
            >
              {productIsDisabled ? "Enable Product" : "Disable Product"}
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};
